<template>
  <div>
    <loading-indicator v-if="loading"></loading-indicator>

    <div v-else class="form-group">
      <label for="report_option_var_id">Limit Report by Reseller</label>
      <select
        id="report_option_var_id"
        v-model="value.id"
        class="form-control"
        @change="markCompleted()"
      >
        <option v-if="varResellers.length == 0" disabled :value="null">
          -- Invalid Selection --
        </option>
        <option v-if="varResellers.length > 1" disabled :value="null">
          -- Select One --
        </option>
        <!-- eslint-disable-next-line -->
        <option v-if="varResellers.length > 1" value="">All Resellers</option>
        <option
          v-for="theVar in varResellers"
          :key="`var-${theVar.id}`"
          :value="theVar.id"
        >
          {{ theVar.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import ProvidesCompletedOptionTracking from "./ProvidesCompletedOptionTracking";

export default {
  mixins: [ProvidesCompletedOptionTracking],

  props: {
    value: {
      required: true,
      type: Object,
    },

    varResellers: {
      required: true,
      type: Array,
    },

    allAllowed: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: true,
      vars: [],
    };
  },

  watch: {
    varResellers() {
      if (this.varResellers.length === 1) {
        this.value.id = this.varResellers[0].id;
      }
    },
  },

  created() {
    this.initializeCompletedTracking();
    this.vars = this.varResellers;

    if (this.value.id !== null) {
      this.markCompleted();
    } else if (this.vars.length === 1) {
      this.value.id = this.vars[0].id;
      this.markCompleted();
    }

    this.loading = false;
    this.$emit("loaded");
  },
};
</script>
